<template>
  <div class="lynda-answer">
    <template v-for="(block, i) in blocks">
      <AnswerMarkdown
        v-if="block.kind === 'markdown'"
        :key="i"
        :token="block.token"
      />
      <p
        v-else-if="block.kind === 'unavailable'"
        :key="i"
        class="lynda-visual-unavailable"
      >
        {{ block.text }}
      </p>
      <AnswerChart
        v-else-if="block.widget.type === 'chart'"
        :key="i"
        :chart="block.widget"
      />
      <aside
        v-else-if="block.widget.type === 'callout'"
        :key="i"
        class="lynda-callout"
        :data-variant="block.widget.variant"
      >
        <strong>{{ block.widget.title }}</strong>
        <p>{{ block.widget.content }}</p>
      </aside>
      <figure
        v-else-if="block.widget.type === 'table'"
        :key="i"
        class="lynda-visual"
      >
        <figcaption>{{ block.widget.title }}</figcaption>
        <div
          class="lynda-table-scroll"
          role="region"
          tabindex="0"
          :aria-label="block.widget.title"
        >
          <table>
            <thead>
              <tr>
                <th
                  v-for="col in block.widget.columns"
                  :key="col.key"
                  scope="col"
                >
                  {{ col.label }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, r) in block.widget.rows" :key="r">
                <td v-for="(cell, c) in row" :key="c">{{ cell }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </figure>
    </template>
  </div>
</template>
<script>
import { answerBlocks } from './answerBlocks'
import AnswerMarkdown from './AnswerMarkdown'
import AnswerChart from './AnswerChart.vue'
export default {
  name: 'LyndaAnswer',
  components: { AnswerMarkdown, AnswerChart },
  props: { source: String },
  computed: {
    blocks() {
      return answerBlocks(this.source)
    },
  },
}
</script>
